module.exports = __webpack_public_path__ + "assets/815d249fae1d0daf1a1a867a7ee9f9d0.mp4";